<template>
  <sub-page title="我的地址">
    <div class="address-page">
      <div class="empty-state">
        <img :src="emptyImg" class="empty-img" alt="empty" />
        <div class="empty-text">暂无地址</div>
        <button class="add-btn" @click="handleAdd">添加地址</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyAddress',
  components: { SubPage },
  data() {
    return {
      emptyImg: require('@/assets/icons/empty.png')
    }
  },
  methods: {
    handleAdd() {
      this.$alert('添加地址')
    }
  }
}
</script>

<style scoped>
.address-page {
  background: #F3F8FB;
  min-height: 100%;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(200 * var(--w));
}
.empty-img {
  width: calc(240 * var(--w));
  height: calc(240 * var(--w));
  object-fit: contain;
  opacity: 0.9;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
.add-btn {
  margin-top: calc(60 * var(--w));
  width: calc(400 * var(--w));
  height: calc(88 * var(--w));
  background: linear-gradient(90deg, #2E8CF6, #5EA9FA);
  color: #fff;
  font-size: calc(32 * var(--w));
  font-weight: 500;
  border: none;
  border-radius: calc(44 * var(--w));
  cursor: pointer;
  box-shadow: 0 calc(6 * var(--w)) calc(16 * var(--w)) rgba(46, 140, 246, 0.3);
  transition: all 0.2s;
}
.add-btn:active {
  opacity: 0.9;
  transform: scale(0.98);
}
</style>



// WEBPACK FOOTER //
// src/pages/MyAddress.vue